import BottomNavLayout from "../../components/BottomNavLayout";
import PubHeader from "../../components/PubHeader";
import ListRecord from "./ListRecord";

const IllegalRecord = () => {
  return (
    <BottomNavLayout>
      <PubHeader title="违规记录" />
      <ListRecord />
    </BottomNavLayout>
  )
}

export default IllegalRecord